var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"is-size-5 has-text-weight-bold mb-lg"},[_vm._v("Finance Settings")]),_c('div',{staticClass:"mb-lg pb-lg has-border-b"},[_c('SalesTerms')],1),_c('div',{staticClass:"mb-lg"},[_c('ExpenseCategories')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }